<template>
  <RevCard class="space-y-16 p-16">
    <div class="relative">
      <h3 class="heading-3">{{ i18n(translations.title) }}</h3>
    </div>

    <div>
      <div class="body-2 mb-4">
        {{ i18n(translations.expectedShippingDate) }}
      </div>
      <div class="body-1-bold">
        <template v-if="!orderDetails.shippingDate">-</template>
        <template v-else>
          {{ i18n.date(new Date(orderDetails.shippingDate), DATE_FORMAT) }}
        </template>
      </div>
    </div>

    <div>
      <div class="body-2 mb-1">
        {{ i18n(translations.shippingProvider) }}
      </div>
      <div class="body-1-bold">
        {{ orderDetails.shipping?.carrier?.name }}
      </div>
    </div>

    <div>
      <div class="body-2 mb-4">
        {{ i18n(translations.trackingNumber) }}
      </div>
      <div class="body-1-bold" data-test="order-tracking-number">
        <span class="mr-8">{{
          orderDetails.shipping?.trackingNumber || '-'
        }}</span>
        <RevLink
          v-if="orderDetails.shipping?.trackingLink?.href"
          target="_blank"
          :to="orderDetails.shipping?.trackingLink?.href"
        >
          {{ i18n(translations.trackShipping) }}
        </RevLink>
      </div>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevLink } from '@ds/components/Link'

import type { OrderDetails } from '../../OrderDetails.types'

import { DATE_FORMAT } from './ShippingDetails.constants'
import translations from './ShippingDetails.translations'

defineProps<{ orderDetails: OrderDetails }>()

const i18n = useI18n()
</script>
